import Cookies from "js-cookie";

export function stopTracking() {
  gtag("consent", "update", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied"
  });
  gtag("set", { allow_google_signals: false });
  gtag("set", { allow_ad_personalization_signals: false });
  gtag("config", { allow_ad_personalization_signals: false });
  window.clarity("consent", false);
  window.clarity("stop");
  window["ga-disable-GTM-KTM7BX7V"] = true;
  clearCookies();
}

async function clearCookies() {
  if (typeof cookieStore.getAll !== "function") return;
  const cookieNames = (await cookieStore.getAll()).map((cookie) => cookie.name);
  const constToDeleteCookies = cookieNames.filter((c) => c.startsWith("_ga"));
  if (!Array.isArray(constToDeleteCookies)) return;
  constToDeleteCookies.forEach(async (cookieName) => {
    try {
      await cookieStore.delete(cookieName);
    } catch (error) {
      console.log(`Error deleting cookie1: ${error}`);
    }
  });
}

export function setCookisAccept() {
  Cookies.set("cookies-accept", "all", { expires: 365 });
  gtag("consent", "update", {
    ad_storage: "granted",
    ad_user_data: "granted",
    ad_personalization: "granted",
    analytics_storage: "granted"
  });
  window.clarity("consent");
  window.clarity("start");
  window["ga-disable-GTM-KTM7BX7V"] = false;
}

export function setCookisDenied() {
  Cookies.set("cookies-accept", "rejected", { expires: 365 });
  stopTracking();
}
